<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="textoMes"
        label="Selecciona año y mes"
        prepend-inner-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        outlined
        dense
        hide-details
      />
    </template>

    <v-date-picker
      :value="value"
      type="month"
      :max="maxMes"
      locale="es"
      no-title
      @input="seleccionar"
    />
  </v-menu>
</template>

<script>
export default {
  props: {
    value: String   // 'YYYY-MM'
  },
  data() {
    return {
      menu: false,
      maxMes: `${new Date().getFullYear() + 2}-12`
    };
  },
  computed: {
    textoMes() {
      if (!this.value) return '';
      const [anio, mes] = this.value.split('-').map(Number);
      const nombre = new Date(anio, mes - 1, 1)
        .toLocaleDateString('es-MX', { month: 'long' });
      return `${nombre} ${anio}`;
    }
  },
  methods: {
    seleccionar(mes) {
      this.menu = false;
      if (mes === this.value) return;   // mismo mes: no recarga
      this.$emit('input', mes);         // actualiza el v-model del padre
      this.$emit('change', mes);        // avisa para recargar
    }
  }
};
</script>